import { useContext } from 'react'

import { Text } from '@chakra-ui/react'

import { StarRatingContext } from './StarRating'

export const StarRatingLabel = () => {
    const { rating, labelText } = useContext(StarRatingContext)

    return (
        <Text mb={2} fontSize={'sm'} fontWeight={'medium'} color={'text.main'}>
            {labelText(rating)}
        </Text>
    )
}
